<div
  class="project-trend"
  *ngIf="showTrend"
  [ngClass]="colorTrend()"
  ngbTooltip="{{ tooltip }}"
  placement="top auto"
  container="body"
>
  <i
    class="glyphicon glyphicon--valign-baseline"
    [ngClass]="{
      'glyphicon-arrow-up': trend > 0,
      'glyphicon-arrow-down': trend < 0
    }"
  >
  </i
  >{{ humanReadableTrend }}%
</div>
